import { createStore, setStateHelper } from "@neonumy/ant-design";
import { StoreApi, UseBoundStore } from "zustand";
import { CompanyFilters } from "../types/Home";

interface CompanyFiltersStore {
  companyFilters: CompanyFilters | undefined;
  resetStore: () => void;
  setCompanyFilters: (companyFilters: CompanyFilters | undefined) => void;
}

const useCompanyFiltersStore: UseBoundStore<StoreApi<CompanyFiltersStore>> =
  createStore<CompanyFiltersStore>((set: (fn: (draft: CompanyFiltersStore) => void) => void) => ({
    companyFilters: undefined,
    resetStore: () => {
      set(() => ({
        companyFilters: undefined,
      }));
    },
    setCompanyFilters: (companyFilters: CompanyFilters | undefined) => {
      setStateHelper("companyFilters", companyFilters, set);
    },
  }));

export default useCompanyFiltersStore;
